<template>
  <div>
    <v-autocomplete
      @input="setEmailTemplate"
      :items="emailTemplates"
      :value="email_template_id"
      :label="label"
      item-text="name"
      item-value="id"
      :error-messages="errorMessages"
      :disable="disabled"
      no-data-text="No dealer selected -or- dealer has no Email Templates"
      :append-outer-icon="previewIcon"
      @click:append-outer="doPreview"
      return-object
    >
    <template v-slot:selection="data">
      <v-icon v-if="data.item.global_template" color="green">mdi-earth</v-icon>
      <v-list-item-content>
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
      </v-list-item-content>

    </template>
    <template v-slot:item="data">
      <v-chip class="mr-1" v-if="data.item.global_template">
        <v-icon color="green">mdi-earth</v-icon>
        Global
      </v-chip>
      <v-list-item-content>
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
    <preview-template-dialog
      v-model="showPreviewDialog"
      :email-template-id="email_template_id"
      :email-footer-id="emailTemplateFooterId"
    >
    </preview-template-dialog>
  </div>
</template>

<script>
import { EmailTemplateApi } from '@/services'
import PreviewTemplateDialog from '@/components/email_builder/PreviewTemplateDialog'

export default {
  name: 'email-template-select',
  components: {
    [PreviewTemplateDialog.name]: PreviewTemplateDialog
  },
  props: {
    dealer_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    email_template_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    emailTemplateFooterId: {
      type: [Number, String],
      required: false
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    includeTemplates: {
      // includes templates(is_template) in addition to marked up email templates
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Email Template Name'
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      emailTemplates: [],
      emailTemplate: {},
      showPreviewDialog: false
    }
  },
  computed: {
    previewIcon: function () {
      if (this.showPreview) {
        if (this.emailTemplate.id) {
          return 'mdi-binoculars'
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    dealer_id: function (newDealerId, oldDealerId) {
      if (newDealerId === oldDealerId) {
        return
      }

      // We only want to execute if the dealer_id changed from some val to some other val
      // don't execute the first time dealer_id is set, i.e. oldDealerId is null
      if (newDealerId && oldDealerId) {
        this.setEmailTemplate({})
      }
    },
    email_template_id: function (val) {
      if (val) {
        EmailTemplateApi.getEmailTemplate(parseInt(val))
          .then(et => this.setEmailTemplate(et.data))
          .catch(error => {
            this.$logger.error('Error loading email template into email-template-select', error.message)
            this.$flash({
              showClose: true,
              message: 'Error Loading Email Template. Reload to try again',
              type: 'error'
            })
          })
      } else {
        this.emailTemplate = {}
      }
    }
  },
  mounted: function () {
    this.fetchEmailTemplates()
  },
  methods: {
    doPreview: function () {
      if (this.emailTemplate.id) {
        this.showPreviewDialog = true
      } else {
        alert('This Email Campaign does not have an associated email template to preview.')
      }
    },
    setEmailTemplate: function (selectedEmailTemplate) {
      this.emailTemplate = selectedEmailTemplate
      this.$emit('input', selectedEmailTemplate ? selectedEmailTemplate.id : null)
      this.$emit('update:email_template_id', selectedEmailTemplate ? selectedEmailTemplate.id : null)
      this.$emit('selected-email-template', selectedEmailTemplate)
    },
    fetchEmailTemplates: function () {
      const templateFilter = { view: 'short' }
      // default without filter is to include templates
      // exclude unless we specifically want them
      // TODO - generating a funky query on the serverside
      if (!this.includeTemplates) {
        templateFilter.is_template = false
      }
      if (this.dealer_id) {
        templateFilter.dealer_id = this.dealer_id
      }
      return EmailTemplateApi.fetchEmailTemplates(templateFilter)
        .then((resp) => { this.emailTemplates = resp.data })
        .catch(error => {
          this.$logger.error('Error Fetching EmailTemplates by dealer')
          this.$flash({
            showClose: true,
            message: `Error fetching EmailTemplates by dealer. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    }
  }
}
</script>
